'use strict';

var jsxRuntime = require('react/jsx-runtime');
var stepperContext = require('./stepper-context.js');
var react = require('react');
var classNames = require('classnames');

var step = "Step-module_step__iSKN5";
var stepNumber = "Step-module_stepNumber__2tw-r";
var stepLink = "Step-module_stepLink__ely0O";
var stepActive = "Step-module_stepActive__y-OvD";
var stepPreceding = "Step-module_stepPreceding__t572T";

const Step = (props) => {
    const { title, stepNumber: stepNumber$1, interactive, as, ariaCurrentType = "step", ...rest } = props;
    const context = react.useContext(stepperContext.StepperContext);
    if (context === null) {
        throw new Error("<Stepper.Step> må brukes innenfor <Stepper>");
    }
    const { activeStep, onStepChange } = context;
    const isActive = activeStep === stepNumber$1;
    const isPreceding = stepNumber$1 < activeStep;
    const isInteractive = typeof interactive === "boolean" ? interactive : isPreceding;
    const Component = as || "a";
    return (jsxRuntime.jsx("li", { "aria-current": isActive ? ariaCurrentType : undefined, className: classNames({
            [step]: true,
            [stepActive]: isActive,
            [stepPreceding]: isPreceding,
        }), children: isInteractive ? (jsxRuntime.jsxs(Component, { ...rest, onClick: () => {
                onStepChange(stepNumber$1);
            }, className: stepLink, children: [jsxRuntime.jsx("span", { className: stepNumber, children: stepNumber$1 }), title] })) : (jsxRuntime.jsxs("span", { className: stepLink, children: [jsxRuntime.jsx("span", { className: stepNumber, children: stepNumber$1 }), title] })) }));
};

var stepperContainer = "Stepper-module_stepperContainer__PxwjM";
var stepper = "Stepper-module_stepper__IgQgb";
var stepperUnderline = "Stepper-module_stepperUnderline__EFjbA";

function Stepper(props) {
    const { activeStep, onStepChange, children, ...rest } = props;
    return (jsxRuntime.jsxs("div", { className: stepperContainer, ...rest, children: [jsxRuntime.jsx("ol", { className: stepper, children: jsxRuntime.jsx(stepperContext.StepperContext.Provider, { value: { activeStep: activeStep, onStepChange }, children: children }) }), jsxRuntime.jsx("span", { className: stepperUnderline })] }));
}
Stepper.Step = Step;

module.exports = Stepper;
